const getKeyPrefix = (key: string) => {
    const { hostname } = window.location;
    const [clientName] = hostname.split(".");

    return `${clientName}-${key}`
}

const getItem = (key: string) => {
    return localStorage.getItem(getKeyPrefix(key));
}

const setItem = (key: string, value: string) => {
    return localStorage.setItem(getKeyPrefix(key), value);
}

const removeItem = (key: string) => {
    return localStorage.removeItem(getKeyPrefix(key));
}

export default {
    getItem,
    setItem,
    removeItem
}